// extracted by mini-css-extract-plugin
export default {"container":"NextPageComponent_container__-IKLl","navLink":"NextPageComponent_navLink__joc+f"};